import styled from 'styled-components';
import { Link as NextLink } from '@/i18n/routing';
import Typography from '@/components/core/Typography';
import { ReactNode } from 'react';

export const LinkTypography = styled(Typography)`
    color: ${({ theme }) => theme.colors.palette.blue_500};
    cursor: pointer;
`;

const StyledLink = styled(NextLink)`
    text-decoration: none;
`;

export function Link({
    children,
    href,
    target,
    size,
    variant,
    modifier,
    ...rest
}: {
    children: ReactNode;
    href: any;
    target?: string;
    size: string;
    variant: string;
    modifier: string;
} & Record<string, any>) {
    return (
        <StyledLink href={href} target={target ?? '_self'} {...rest}>
            <LinkTypography
              variant={variant}
              modifier={modifier}
              size={size}
            >{children}
            </LinkTypography>
        </StyledLink>
    );
}
